import React from 'react'
import Scroll from './Scroll'
import styled from 'styled-components'

type Props = {
  members: { name: string; part: string }[]
  next: string
}

const Profile: React.FC<Props> = ({ next, members }) => (
  <section id="top" className="main special">
    <div className="container">
      <div className="content">
        <header className="major">
          <h2>Profile</h2>
        </header>
        <p>
          {members.length}
          人組音楽グループ。YouTubeなどの動画投稿サイトを中心に活動している。
        </p>
        <h3>メンバー</h3>
        <div className="table-wrapper">
          <table>
            <thead>
              <tr>
                <ThCol>名前</ThCol>
                <ThCol>パート</ThCol>
              </tr>
            </thead>
            <tbody>
              {members.map(({ name, part }) => (
                <tr key={name}>
                  <td>{name}</td>
                  <td>{part}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <ul className="actions special">
        <li>
          <Scroll type="id" element={next}>
            <a href={`#${next}`} className="button primary fit-width">
              Songs
            </a>
          </Scroll>
        </li>
      </ul>
    </div>
  </section>
)

const ThCol = styled.th`
  text-align: center;
`

export default Profile
